// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Permission;
(function (Permission) {
    Permission["UNKNOWN"] = "UNKNOWN";
    Permission["FEATURE_FLAG_READ"] = "FEATURE_FLAG_READ";
    Permission["FEATURE_FLAG_WRITE"] = "FEATURE_FLAG_WRITE";
    Permission["FEATURE_FLAG_CREATE"] = "FEATURE_FLAG_CREATE";
    Permission["OUTAGE_REPORT"] = "OUTAGE_REPORT";
    Permission["CUSTOMIZATION_FLAGS_WRITE"] = "CUSTOMIZATION_FLAGS_WRITE";
    Permission["FEATURE_FLAG_SET_LOCATION"] = "FEATURE_FLAG_SET_LOCATION";
    Permission["FEATURE_FLAG_BULK_ADMIN"] = "FEATURE_FLAG_BULK_ADMIN";
    Permission["USER_DELETE"] = "USER_DELETE";
    Permission["USER_WRITE"] = "USER_WRITE";
    Permission["APP_RELEASE_WRITE"] = "APP_RELEASE_WRITE";
    Permission["WEAVE_ACL_MANAGE"] = "WEAVE_ACL_MANAGE";
    Permission["AUDIT_LOG_READ"] = "AUDIT_LOG_READ";
    Permission["WEAVE_ROLE_ACL_READ"] = "WEAVE_ROLE_ACL_READ";
    Permission["USER_RESET"] = "USER_RESET";
    Permission["WEAVE_USER_BULK_ADMIN"] = "WEAVE_USER_BULK_ADMIN";
    Permission["SYNC_APP_PRACTICE_ADMIN_MANAGE"] = "SYNC_APP_PRACTICE_ADMIN_MANAGE";
    Permission["SYNC_APP_PRACTICE_ADMIN_INSTALL"] = "SYNC_APP_PRACTICE_ADMIN_INSTALL";
    Permission["DATA_SOURCE_UPLOAD_CSV"] = "DATA_SOURCE_UPLOAD_CSV";
    Permission["MANAGE_QUICK_ACTIONS"] = "MANAGE_QUICK_ACTIONS";
    Permission["TAG_MANAGE"] = "TAG_MANAGE";
    Permission["SYNC_APP_INSTALL_ADVANCED"] = "SYNC_APP_INSTALL_ADVANCED";
    Permission["ANALYTICS_ADVANCED"] = "ANALYTICS_ADVANCED";
    Permission["SYNC_APP_MANAGE_ADVANCED"] = "SYNC_APP_MANAGE_ADVANCED";
    Permission["SYNC_APP_MANAGE"] = "SYNC_APP_MANAGE";
    Permission["SYNC_APP_BETA_FEATURE"] = "SYNC_APP_BETA_FEATURE";
    Permission["TURN_OFF_WEAVE_VERIFY"] = "TURN_OFF_WEAVE_VERIFY";
    Permission["DEV_TOOLS"] = "DEV_TOOLS";
    Permission["MOBILE_REPORTING_MANAGE"] = "MOBILE_REPORTING_MANAGE";
    Permission["TEAM_CHAT_MANAGE"] = "TEAM_CHAT_MANAGE";
    Permission["CALL_RECORDING_SETTING_WRITE"] = "CALL_RECORDING_SETTING_WRITE";
    Permission["CALL_RECORDING_READ"] = "CALL_RECORDING_READ";
    Permission["CALL_FORWARDING_SETTING_WRITE"] = "CALL_FORWARDING_SETTING_WRITE";
    Permission["OFFICE_HOURS_SETTING_WRITE"] = "OFFICE_HOURS_SETTING_WRITE";
    Permission["VOICEMAIL_OVERRIDE_WRITE"] = "VOICEMAIL_OVERRIDE_WRITE";
    Permission["DENY_MOBILE_ACCESS"] = "DENY_MOBILE_ACCESS";
    Permission["DATACENTER_MOVE_WRITE"] = "DATACENTER_MOVE_WRITE";
    Permission["BILLING_INFORMATION_READ"] = "BILLING_INFORMATION_READ";
    Permission["BILLING_INFORMATION_WRITE"] = "BILLING_INFORMATION_WRITE";
    Permission["E911_ADDRESS_READ_WRITE"] = "E911_ADDRESS_READ_WRITE";
    Permission["SIP_PROFILE_STATUS_WRITE"] = "SIP_PROFILE_STATUS_WRITE";
    Permission["CALL_GROUPS_WRITE"] = "CALL_GROUPS_WRITE";
    Permission["CREATE_DEVICES"] = "CREATE_DEVICES";
    Permission["PHONE_TREE_WRITE"] = "PHONE_TREE_WRITE";
    Permission["VOICEMAIL_PIN_WRITE"] = "VOICEMAIL_PIN_WRITE";
    Permission["FORMS_UPLOAD_MANAGE"] = "FORMS_UPLOAD_MANAGE";
    Permission["CALL_QUEUE_WRITE"] = "CALL_QUEUE_WRITE";
    Permission["SECURITY_SETTINGS_WRITE"] = "SECURITY_SETTINGS_WRITE";
    Permission["SECURITY_SETTINGS_READ"] = "SECURITY_SETTINGS_READ";
    Permission["PHONE_DEPARTMENTS_WRITE"] = "PHONE_DEPARTMENTS_WRITE";
    Permission["CALL_RECORDING_DELETE"] = "CALL_RECORDING_DELETE";
    Permission["VIEW_FULL_PERSON_DATA"] = "VIEW_FULL_PERSON_DATA";
    Permission["MANAGE_ADD_ON_SUBSCRIPTIONS"] = "MANAGE_ADD_ON_SUBSCRIPTIONS";
    Permission["PHONE_CONTACTS_WRITE"] = "PHONE_CONTACTS_WRITE";
    Permission["PHONE_DEVICE_WRITE"] = "PHONE_DEVICE_WRITE";
    Permission["VOICEMAIL_SHARE_MESSAGE_WRITE"] = "VOICEMAIL_SHARE_MESSAGE_WRITE";
    Permission["VOICEMAIL_BOX_WRITE"] = "VOICEMAIL_BOX_WRITE";
    Permission["EXTENSION_WRITE"] = "EXTENSION_WRITE";
    Permission["API_ACCESS"] = "API_ACCESS";
    Permission["PHONE_FULL_ACCESS"] = "PHONE_FULL_ACCESS";
    Permission["WRITE_LOCATIONS"] = "WRITE_LOCATIONS";
    Permission["WRITE_MULTI_LOCATION_CONFIGS"] = "WRITE_MULTI_LOCATION_CONFIGS";
    Permission["MESSAGE_SETTINGS_MANAGE"] = "MESSAGE_SETTINGS_MANAGE";
    Permission["MESSAGE_QUEUE_MANAGE"] = "MESSAGE_QUEUE_MANAGE";
    Permission["AUTO_MESSAGING_MANAGE"] = "AUTO_MESSAGING_MANAGE";
    Permission["MANUAL_MESSAGE_TEMPLATES_MANAGE"] = "MANUAL_MESSAGE_TEMPLATES_MANAGE";
    Permission["SMS_INBOX_SETTINGS_MANAGE"] = "SMS_INBOX_SETTINGS_MANAGE";
    Permission["SMS_INBOX_MANAGE"] = "SMS_INBOX_MANAGE";
    Permission["SMS_INBOX_MESSAGE_DELETE"] = "SMS_INBOX_MESSAGE_DELETE";
    Permission["BULK_TEXTING_MANAGE"] = "BULK_TEXTING_MANAGE";
    Permission["EMAIL_MARKETING_MANAGE"] = "EMAIL_MARKETING_MANAGE";
    Permission["EMAIL_SETTINGS_MANAGE"] = "EMAIL_SETTINGS_MANAGE";
    Permission["FAX_SETTINGS_MANAGE"] = "FAX_SETTINGS_MANAGE";
    Permission["FAX_INBOX_MANAGE"] = "FAX_INBOX_MANAGE";
    Permission["FAX_HISTORY_READ"] = "FAX_HISTORY_READ";
    Permission["FAX_DELETE"] = "FAX_DELETE";
    Permission["MESSAGING_PUBLIC_MEDIA_READ"] = "MESSAGING_PUBLIC_MEDIA_READ";
    Permission["MESSAGING_PUBLIC_MEDIA_MANAGE"] = "MESSAGING_PUBLIC_MEDIA_MANAGE";
    Permission["PAYMENTS_REFUNDS"] = "PAYMENTS_REFUNDS";
    Permission["PAYMENTS_EXPRESS_DASHBOARD"] = "PAYMENTS_EXPRESS_DASHBOARD";
    Permission["PAYMENTS_EXPORTS"] = "PAYMENTS_EXPORTS";
    Permission["PAYMENTS_PROCESSING_WRITE"] = "PAYMENTS_PROCESSING_WRITE";
    Permission["PAYMENTS_SETTINGS_VIEW_ONLY"] = "PAYMENTS_SETTINGS_VIEW_ONLY";
    Permission["PAYMENTS_ALLOW_DISCONNECT_STRIPE_PROCESSOR"] = "PAYMENTS_ALLOW_DISCONNECT_STRIPE_PROCESSOR";
    Permission["PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY"] = "PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY";
    Permission["REVIEW_REPLY_WRITE"] = "REVIEW_REPLY_WRITE";
    Permission["REVIEW_SETTINGS"] = "REVIEW_SETTINGS";
    Permission["REVIEW_READ"] = "REVIEW_READ";
    Permission["REVIEW_ANALYTICS_READ"] = "REVIEW_ANALYTICS_READ";
    Permission["FORMS_PROVIDER_REVIEW_MANAGE"] = "FORMS_PROVIDER_REVIEW_MANAGE";
    Permission["FORMS_PROVIDER_REVIEW"] = "FORMS_PROVIDER_REVIEW";
    Permission["FORMS_CLONE_MANAGE"] = "FORMS_CLONE_MANAGE";
    Permission["ANALYTICS_READ"] = "ANALYTICS_READ";
    Permission["ANALYTICS_READ_PRACTICE"] = "ANALYTICS_READ_PRACTICE";
    Permission["ANALYTICS_READ_PHONE"] = "ANALYTICS_READ_PHONE";
    Permission["ANALYTICS_READ_MESSAGING"] = "ANALYTICS_READ_MESSAGING";
    Permission["ANALYTICS_READ_APPOINTMENT"] = "ANALYTICS_READ_APPOINTMENT";
    Permission["ANALYTICS_READ_RECALL"] = "ANALYTICS_READ_RECALL";
    Permission["INTACCT_INVOICE_DELETE"] = "INTACCT_INVOICE_DELETE";
    Permission["SSO_MANAGE"] = "SSO_MANAGE";
    Permission["LOCATION_SETTINGS_MANAGE"] = "LOCATION_SETTINGS_MANAGE";
    Permission["CALL_INTELLIGENCE_READ"] = "CALL_INTELLIGENCE_READ";
    Permission["CALL_INTELLIGENCE_EDIT_AI_OUTPUT"] = "CALL_INTELLIGENCE_EDIT_AI_OUTPUT";
    Permission["CALL_CLASSIFICATION_READ"] = "CALL_CLASSIFICATION_READ";
    Permission["MANAGE_TASK_UPDATE"] = "MANAGE_TASK_UPDATE";
    Permission["MANAGE_TASK_DELETE"] = "MANAGE_TASK_DELETE";
})(Permission || (Permission = {}));
export var Permission_index;
(function (Permission_index) {
    Permission_index[Permission_index["UNKNOWN"] = 0] = "UNKNOWN";
    Permission_index[Permission_index["FEATURE_FLAG_READ"] = 10] = "FEATURE_FLAG_READ";
    Permission_index[Permission_index["FEATURE_FLAG_WRITE"] = 11] = "FEATURE_FLAG_WRITE";
    Permission_index[Permission_index["FEATURE_FLAG_CREATE"] = 12] = "FEATURE_FLAG_CREATE";
    Permission_index[Permission_index["OUTAGE_REPORT"] = 13] = "OUTAGE_REPORT";
    Permission_index[Permission_index["CUSTOMIZATION_FLAGS_WRITE"] = 14] = "CUSTOMIZATION_FLAGS_WRITE";
    Permission_index[Permission_index["FEATURE_FLAG_SET_LOCATION"] = 15] = "FEATURE_FLAG_SET_LOCATION";
    Permission_index[Permission_index["FEATURE_FLAG_BULK_ADMIN"] = 16] = "FEATURE_FLAG_BULK_ADMIN";
    Permission_index[Permission_index["USER_DELETE"] = 20] = "USER_DELETE";
    Permission_index[Permission_index["USER_WRITE"] = 21] = "USER_WRITE";
    Permission_index[Permission_index["APP_RELEASE_WRITE"] = 22] = "APP_RELEASE_WRITE";
    Permission_index[Permission_index["WEAVE_ACL_MANAGE"] = 23] = "WEAVE_ACL_MANAGE";
    Permission_index[Permission_index["AUDIT_LOG_READ"] = 24] = "AUDIT_LOG_READ";
    Permission_index[Permission_index["WEAVE_ROLE_ACL_READ"] = 25] = "WEAVE_ROLE_ACL_READ";
    Permission_index[Permission_index["USER_RESET"] = 26] = "USER_RESET";
    Permission_index[Permission_index["WEAVE_USER_BULK_ADMIN"] = 27] = "WEAVE_USER_BULK_ADMIN";
    Permission_index[Permission_index["SYNC_APP_PRACTICE_ADMIN_MANAGE"] = 30] = "SYNC_APP_PRACTICE_ADMIN_MANAGE";
    Permission_index[Permission_index["SYNC_APP_PRACTICE_ADMIN_INSTALL"] = 31] = "SYNC_APP_PRACTICE_ADMIN_INSTALL";
    Permission_index[Permission_index["DATA_SOURCE_UPLOAD_CSV"] = 32] = "DATA_SOURCE_UPLOAD_CSV";
    Permission_index[Permission_index["MANAGE_QUICK_ACTIONS"] = 40] = "MANAGE_QUICK_ACTIONS";
    Permission_index[Permission_index["TAG_MANAGE"] = 41] = "TAG_MANAGE";
    Permission_index[Permission_index["SYNC_APP_INSTALL_ADVANCED"] = 203] = "SYNC_APP_INSTALL_ADVANCED";
    Permission_index[Permission_index["ANALYTICS_ADVANCED"] = 204] = "ANALYTICS_ADVANCED";
    Permission_index[Permission_index["SYNC_APP_MANAGE_ADVANCED"] = 205] = "SYNC_APP_MANAGE_ADVANCED";
    Permission_index[Permission_index["SYNC_APP_MANAGE"] = 206] = "SYNC_APP_MANAGE";
    Permission_index[Permission_index["SYNC_APP_BETA_FEATURE"] = 207] = "SYNC_APP_BETA_FEATURE";
    Permission_index[Permission_index["TURN_OFF_WEAVE_VERIFY"] = 208] = "TURN_OFF_WEAVE_VERIFY";
    Permission_index[Permission_index["DEV_TOOLS"] = 209] = "DEV_TOOLS";
    Permission_index[Permission_index["MOBILE_REPORTING_MANAGE"] = 210] = "MOBILE_REPORTING_MANAGE";
    Permission_index[Permission_index["TEAM_CHAT_MANAGE"] = 211] = "TEAM_CHAT_MANAGE";
    Permission_index[Permission_index["CALL_RECORDING_SETTING_WRITE"] = 400] = "CALL_RECORDING_SETTING_WRITE";
    Permission_index[Permission_index["CALL_RECORDING_READ"] = 401] = "CALL_RECORDING_READ";
    Permission_index[Permission_index["CALL_FORWARDING_SETTING_WRITE"] = 402] = "CALL_FORWARDING_SETTING_WRITE";
    Permission_index[Permission_index["OFFICE_HOURS_SETTING_WRITE"] = 403] = "OFFICE_HOURS_SETTING_WRITE";
    Permission_index[Permission_index["VOICEMAIL_OVERRIDE_WRITE"] = 404] = "VOICEMAIL_OVERRIDE_WRITE";
    Permission_index[Permission_index["DENY_MOBILE_ACCESS"] = 405] = "DENY_MOBILE_ACCESS";
    Permission_index[Permission_index["DATACENTER_MOVE_WRITE"] = 406] = "DATACENTER_MOVE_WRITE";
    Permission_index[Permission_index["BILLING_INFORMATION_READ"] = 407] = "BILLING_INFORMATION_READ";
    Permission_index[Permission_index["BILLING_INFORMATION_WRITE"] = 408] = "BILLING_INFORMATION_WRITE";
    Permission_index[Permission_index["E911_ADDRESS_READ_WRITE"] = 409] = "E911_ADDRESS_READ_WRITE";
    Permission_index[Permission_index["SIP_PROFILE_STATUS_WRITE"] = 410] = "SIP_PROFILE_STATUS_WRITE";
    Permission_index[Permission_index["CALL_GROUPS_WRITE"] = 411] = "CALL_GROUPS_WRITE";
    Permission_index[Permission_index["CREATE_DEVICES"] = 412] = "CREATE_DEVICES";
    Permission_index[Permission_index["PHONE_TREE_WRITE"] = 413] = "PHONE_TREE_WRITE";
    Permission_index[Permission_index["VOICEMAIL_PIN_WRITE"] = 414] = "VOICEMAIL_PIN_WRITE";
    Permission_index[Permission_index["FORMS_UPLOAD_MANAGE"] = 415] = "FORMS_UPLOAD_MANAGE";
    Permission_index[Permission_index["CALL_QUEUE_WRITE"] = 416] = "CALL_QUEUE_WRITE";
    Permission_index[Permission_index["SECURITY_SETTINGS_WRITE"] = 417] = "SECURITY_SETTINGS_WRITE";
    Permission_index[Permission_index["SECURITY_SETTINGS_READ"] = 418] = "SECURITY_SETTINGS_READ";
    Permission_index[Permission_index["PHONE_DEPARTMENTS_WRITE"] = 419] = "PHONE_DEPARTMENTS_WRITE";
    Permission_index[Permission_index["CALL_RECORDING_DELETE"] = 420] = "CALL_RECORDING_DELETE";
    Permission_index[Permission_index["VIEW_FULL_PERSON_DATA"] = 421] = "VIEW_FULL_PERSON_DATA";
    Permission_index[Permission_index["MANAGE_ADD_ON_SUBSCRIPTIONS"] = 422] = "MANAGE_ADD_ON_SUBSCRIPTIONS";
    Permission_index[Permission_index["PHONE_CONTACTS_WRITE"] = 423] = "PHONE_CONTACTS_WRITE";
    Permission_index[Permission_index["PHONE_DEVICE_WRITE"] = 424] = "PHONE_DEVICE_WRITE";
    Permission_index[Permission_index["VOICEMAIL_SHARE_MESSAGE_WRITE"] = 425] = "VOICEMAIL_SHARE_MESSAGE_WRITE";
    Permission_index[Permission_index["VOICEMAIL_BOX_WRITE"] = 426] = "VOICEMAIL_BOX_WRITE";
    Permission_index[Permission_index["EXTENSION_WRITE"] = 427] = "EXTENSION_WRITE";
    Permission_index[Permission_index["API_ACCESS"] = 428] = "API_ACCESS";
    Permission_index[Permission_index["PHONE_FULL_ACCESS"] = 429] = "PHONE_FULL_ACCESS";
    Permission_index[Permission_index["WRITE_LOCATIONS"] = 500] = "WRITE_LOCATIONS";
    Permission_index[Permission_index["WRITE_MULTI_LOCATION_CONFIGS"] = 501] = "WRITE_MULTI_LOCATION_CONFIGS";
    Permission_index[Permission_index["MESSAGE_SETTINGS_MANAGE"] = 603] = "MESSAGE_SETTINGS_MANAGE";
    Permission_index[Permission_index["MESSAGE_QUEUE_MANAGE"] = 604] = "MESSAGE_QUEUE_MANAGE";
    Permission_index[Permission_index["AUTO_MESSAGING_MANAGE"] = 605] = "AUTO_MESSAGING_MANAGE";
    Permission_index[Permission_index["MANUAL_MESSAGE_TEMPLATES_MANAGE"] = 606] = "MANUAL_MESSAGE_TEMPLATES_MANAGE";
    Permission_index[Permission_index["SMS_INBOX_SETTINGS_MANAGE"] = 610] = "SMS_INBOX_SETTINGS_MANAGE";
    Permission_index[Permission_index["SMS_INBOX_MANAGE"] = 611] = "SMS_INBOX_MANAGE";
    Permission_index[Permission_index["SMS_INBOX_MESSAGE_DELETE"] = 612] = "SMS_INBOX_MESSAGE_DELETE";
    Permission_index[Permission_index["BULK_TEXTING_MANAGE"] = 620] = "BULK_TEXTING_MANAGE";
    Permission_index[Permission_index["EMAIL_MARKETING_MANAGE"] = 621] = "EMAIL_MARKETING_MANAGE";
    Permission_index[Permission_index["EMAIL_SETTINGS_MANAGE"] = 622] = "EMAIL_SETTINGS_MANAGE";
    Permission_index[Permission_index["FAX_SETTINGS_MANAGE"] = 630] = "FAX_SETTINGS_MANAGE";
    Permission_index[Permission_index["FAX_INBOX_MANAGE"] = 631] = "FAX_INBOX_MANAGE";
    Permission_index[Permission_index["FAX_HISTORY_READ"] = 632] = "FAX_HISTORY_READ";
    Permission_index[Permission_index["FAX_DELETE"] = 633] = "FAX_DELETE";
    Permission_index[Permission_index["MESSAGING_PUBLIC_MEDIA_READ"] = 640] = "MESSAGING_PUBLIC_MEDIA_READ";
    Permission_index[Permission_index["MESSAGING_PUBLIC_MEDIA_MANAGE"] = 641] = "MESSAGING_PUBLIC_MEDIA_MANAGE";
    Permission_index[Permission_index["PAYMENTS_REFUNDS"] = 700] = "PAYMENTS_REFUNDS";
    Permission_index[Permission_index["PAYMENTS_EXPRESS_DASHBOARD"] = 701] = "PAYMENTS_EXPRESS_DASHBOARD";
    Permission_index[Permission_index["PAYMENTS_EXPORTS"] = 702] = "PAYMENTS_EXPORTS";
    Permission_index[Permission_index["PAYMENTS_PROCESSING_WRITE"] = 703] = "PAYMENTS_PROCESSING_WRITE";
    Permission_index[Permission_index["PAYMENTS_SETTINGS_VIEW_ONLY"] = 704] = "PAYMENTS_SETTINGS_VIEW_ONLY";
    Permission_index[Permission_index["PAYMENTS_ALLOW_DISCONNECT_STRIPE_PROCESSOR"] = 705] = "PAYMENTS_ALLOW_DISCONNECT_STRIPE_PROCESSOR";
    Permission_index[Permission_index["PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY"] = 706] = "PAYMENTS_REFUNDS_AND_INVOICES_VIEW_ONLY";
    Permission_index[Permission_index["REVIEW_REPLY_WRITE"] = 800] = "REVIEW_REPLY_WRITE";
    Permission_index[Permission_index["REVIEW_SETTINGS"] = 801] = "REVIEW_SETTINGS";
    Permission_index[Permission_index["REVIEW_READ"] = 802] = "REVIEW_READ";
    Permission_index[Permission_index["REVIEW_ANALYTICS_READ"] = 803] = "REVIEW_ANALYTICS_READ";
    Permission_index[Permission_index["FORMS_PROVIDER_REVIEW_MANAGE"] = 901] = "FORMS_PROVIDER_REVIEW_MANAGE";
    Permission_index[Permission_index["FORMS_PROVIDER_REVIEW"] = 902] = "FORMS_PROVIDER_REVIEW";
    Permission_index[Permission_index["FORMS_CLONE_MANAGE"] = 903] = "FORMS_CLONE_MANAGE";
    Permission_index[Permission_index["ANALYTICS_READ"] = 1001] = "ANALYTICS_READ";
    Permission_index[Permission_index["ANALYTICS_READ_PRACTICE"] = 1002] = "ANALYTICS_READ_PRACTICE";
    Permission_index[Permission_index["ANALYTICS_READ_PHONE"] = 1003] = "ANALYTICS_READ_PHONE";
    Permission_index[Permission_index["ANALYTICS_READ_MESSAGING"] = 1004] = "ANALYTICS_READ_MESSAGING";
    Permission_index[Permission_index["ANALYTICS_READ_APPOINTMENT"] = 1005] = "ANALYTICS_READ_APPOINTMENT";
    Permission_index[Permission_index["ANALYTICS_READ_RECALL"] = 1006] = "ANALYTICS_READ_RECALL";
    Permission_index[Permission_index["INTACCT_INVOICE_DELETE"] = 1100] = "INTACCT_INVOICE_DELETE";
    Permission_index[Permission_index["SSO_MANAGE"] = 1190] = "SSO_MANAGE";
    Permission_index[Permission_index["LOCATION_SETTINGS_MANAGE"] = 1200] = "LOCATION_SETTINGS_MANAGE";
    Permission_index[Permission_index["CALL_INTELLIGENCE_READ"] = 1201] = "CALL_INTELLIGENCE_READ";
    Permission_index[Permission_index["CALL_INTELLIGENCE_EDIT_AI_OUTPUT"] = 1202] = "CALL_INTELLIGENCE_EDIT_AI_OUTPUT";
    Permission_index[Permission_index["CALL_CLASSIFICATION_READ"] = 1203] = "CALL_CLASSIFICATION_READ";
    Permission_index[Permission_index["MANAGE_TASK_UPDATE"] = 1301] = "MANAGE_TASK_UPDATE";
    Permission_index[Permission_index["MANAGE_TASK_DELETE"] = 1302] = "MANAGE_TASK_DELETE";
})(Permission_index || (Permission_index = {}));
